import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { ReactElement, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BlockBuilder } from 'src/v3/components/show-notes-editor'
import { modalPaperProps } from 'src/v3/utilities/modal-styles'
import { PIPELINE_SHOW_NOTES_BASE_PATH } from '../constants'

type Props = {
  isOpen: boolean
  onClose: () => void
  showNotesID: string
  showNotesName: string
}

export default function CourseShowNotesModal({
  isOpen,
  onClose,
  showNotesID,
  showNotesName,
}: Props): ReactElement {
  let [queryClient] = useState(() => new QueryClient())

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      slotProps={{
        paper: {
          ...modalPaperProps,
          sx: { ...modalPaperProps.sx, height: '90vh' },
        },
      }}
      maxWidth="lg"
    >
      <DialogTitle>
        <Box>
          <Typography variant="h6">{showNotesName}</Typography>
          <Typography color="text.secondary" variant="caption">
            Show Notes Editor
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ overflow: 'auto' }}>
        <QueryClientProvider client={queryClient}>
          <BlockBuilder
            showNotesID={showNotesID}
            basePath={PIPELINE_SHOW_NOTES_BASE_PATH}
            showNotesName={showNotesName}
          />
        </QueryClientProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
